export default __webpack_public_path__ + "static/media/xdigrame001.png.pagespeed.ic.UElIOBRUFQ.e9262734.png";